module.exports = __webpack_public_path__ + "media/journey_sweepstakes/scholarship-journey-landing-logo-9a03aa87.png";